import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'

import { Grid, Row, Col } from 'react-bootstrap'
import { PageTitle } from 'Components/PageTitle'
import { AmbassadorWrapper } from 'Components/City/Page/Ambassador/AmbassadorWrapper'
import { AmbassadorSection } from 'Components/City/Page/Ambassador/AmbassadorSection'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import PinUserIcon from 'Assets/Images/icons/pinUser'
import { PATHS } from 'Config/Routing/paths'
import AmbassadorUploadDocumentsWrapper from '../../Ambasador/UploadDocuments/UploadDocumentsForm'
import { getSpy } from '../gql'
import { SectionTitleV2 } from '../../../../../Components/Section/SectionTitleV2'
import { updateUserDocument } from '../../Ambasador/gql'
import GenericFlatButton from '../../../../../Components/GenericFlatButton'
import StyledBreadcrumbs from '../../../../../Components/StyledBreadcrumbs'

const BreadcrumbsAmbassadorUploadDocuments = ({ currentPath }) => {
  return (
    <div>
      <StyledBreadcrumbs
        icon={<PinUserIcon style={{ width: 16 }} />}
        breadcrumbs={[
          {
            label: 'Dashboard',
            link: `${PATHS.main.dashboard}`,
          },
          {
            label: 'Cities',
            link: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
          },
          {
            label: 'Spy',
            link: currentPath.replace('/upload-documents', ''),
          },
          { label: 'Documents' },
        ]}
      />
    </div>
  )
}

const SpyUploadDocuments = ({ countryCode }) => {
  const [loading, setLoading] = useState(false)
  const match = useRouteMatch()
  const {
    params: { spyId },
  } = match

  const [spy, setSpy] = useState(null)

  useEffect(() => {
    fetchSpy()
  }, [])

  const fetchSpy = async () => {
    setLoading(true)
    const res = await getSpy({ id: spyId, onlyPrimary: false })

    const result = await res.json()

    result.data.spy.signedLegalDocuments = result.data.spy.signedLegalDocuments.edges.map(
      e => ({
        dateTime: e.node.dateTime,
        name: e.node.legalDocument.name,
        url: e.node.legalDocument.url,
      }),
    )
    setSpy(result.data.spy)
    setLoading(false)
  }

  if (!spy) {
    return null
  }

  const onDocumentUpdate = async input => {
    try {
      await updateUserDocument({ input })
    } catch (error) {
      /* eslint-disable */
      console.log(`UPDATE_DOC_ERROR:${error}`)
    }
  }

  return (
    <HideWhenBlocked>
      <AmbassadorWrapper>
        <BreadcrumbsAmbassadorUploadDocuments currentPath={match.url} />
        <PageTitle>
          {spy.firstName} {spy.lastName}
          {spy.status && <span className="status">({spy.status})</span>}
        </PageTitle>

        <AmbassadorSection>
          <Grid fluid>
            <Row>
              <Col xs={10}>
                <SectionTitleV2>Spy files history</SectionTitleV2>
              </Col>
              <Col xs={2}>
                <GenericFlatButton
                  title={'Spy profile'}
                  type={'outline'}
                  onClick={() => {
                    const curentUrl = match.url.replace('/upload-documents', '')
                    window.open(curentUrl, '_parent')
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                {spy.id && !loading && (
                  <AmbassadorUploadDocumentsWrapper
                    ambassador={spy}
                    countryCode={countryCode}
                    onDocumentUpdate={onDocumentUpdate}
                    getAmbassador={fetchSpy}
                  />
                )}
              </Col>
            </Row>
          </Grid>
        </AmbassadorSection>
      </AmbassadorWrapper>
    </HideWhenBlocked>
  )
}

export default SpyUploadDocuments
